import CompaniesDataTable from "../../../components/dataTable/tables/CompaniesDataTable";

function CompaniesPageView() {
  return <CompaniesDataTable />;
}

export default CompaniesPageView;
